<div class="card">
  <div class="card-header">
    <h5 class="card-title mb-0">Step 1: Upload Video</h5>
  </div>
  <div class="card-body">
    @if (!startUpload) {
      <file-pond
        #myPond [options]="pondOptions"
        (onaddfile)="pondHandleAddFile($event)"
        (onremovefile)="pondRemoveFile()">
      </file-pond>
    }

    @if (startUpload) {
      <div>
        <div class="d-flex align-items-center">
          <div class="flex-grow-1">
            <h6 class="mb-0">
              <b [ngClass]="progress === 100 ? 'text-success' : 'text-info'">{{ progress }}%</b>
              @if (progress < 100) {
                <span> Uploaded</span>
              }
              @if (progress === 100) {
                <span> Processing...</span>
              }
            </h6>
          </div>
          <div class="flex-shrink-0">
            <h6 [ngClass]="timeLeft === 'Done' ? 'text-success' : ''" class="mb-0">{{ timeLeft }}</h6>
          </div>
        </div>
        <div class="progress bg-primary-subtle mt-2">
          <div class="progress-bar bg-secondary" role="progressbar" [style.width.%]="progress"></div>
        </div>
        @if (timeLeft !== 'Done') {
          <div class="text-center mt-3">
            <button (click)="cancelUpload()" class="btn btn-danger">Cancel Upload</button>
          </div>
        }
      </div>
    }
  </div>
</div>

@if (videoSource && !startUpload) {
  <div class="row">
    <div class="col-lg-7">
      <div class="card">
        <div class="card-header">
          <h5 class="card-title mb-0">Step 2: Preview & Set Baseline</h5>
        </div>
        <div class="card-body">
          <div class="ratio ratio-16x9">
            <video crossorigin="anonymous" #videoElement controls></video>
          </div>
          @if (uploadForm.get('speakerSelected')?.value === 'n') {
            <div
              class="mt-3 text-center d-flex gap-2">
              <button type="button" (click)="markTime('start')" class="btn btn-secondary w-100">
                <i class="ri-skip-back-mini-line align-middle"></i> Mark Start
              </button>
              <button type="button" (click)="markTime('end')" class="btn btn-secondary w-100">
                Mark End <i class="ri-skip-forward-mini-line align-middle"></i>
              </button>
            </div>
          }
        </div>
      </div>
    </div>
    <div class="col-lg-5">
      <div class="card">
        <div class="card-header">
          <h5 class="card-title mb-0">Step 3: Add Details & Confirm</h5>
        </div>
        <div class="card-body">
          <form [formGroup]="uploadForm">
            <div class="mb-3">
              <label for="speaker" class="form-label">Number of Speakers <span class="text-danger">*</span></label>
              <ng-select id="speaker" [items]="speakers"
                bindLabel="name" bindValue="value"
                [searchable]="false"
                formControlName="speakerSelected"
                placeholder="Choose number of speakers"
                [ngClass]="{ 'is-invalid': uploadForm.get('speakerSelected')?.touched && uploadForm.get('speakerSelected')?.errors }">
              </ng-select>
              @if (uploadForm.get('speakerSelected')?.touched && uploadForm.get('speakerSelected')?.errors) {
                <div class="invalid-feedback">
                  Please select the number of speakers.
                </div>
              }
            </div>
            @if (uploadForm.get('speakerSelected')?.value === 'n') {
              <div class="row">
                <div class="col-6">
                  <label for="start_time" class="form-label">Baseline Start <span class="text-danger">*</span></label>
                  <input type="number" class="form-control" id="start_time"
                    formControlName="baseline_start_time" readonly
                    [ngClass]="{ 'is-invalid': uploadForm.get('baseline_start_time')?.touched && uploadForm.get('baseline_start_time')?.errors }">
                </div>
                <div class="col-6">
                  <label for="end_time" class="form-label">Baseline End <span class="text-danger">*</span></label>
                  <input type="number" class="form-control" id="end_time"
                    formControlName="baseline_end_time" readonly
                    [ngClass]="{ 'is-invalid': uploadForm.get('baseline_end_time')?.touched && uploadForm.get('baseline_end_time')?.errors }">
                </div>
                <div class="col-12 mt-2">
                  <p class="text-muted fs-13">Use the "Mark Start/End" buttons under the video to set the baseline.</p>
                </div>
              </div>
            }
          </form>
        </div>
        <div class="card-footer">
          <button type="button" (click)="uploadFile()" class="btn btn-primary w-100" [disabled]="uploadForm.invalid">
            Confirm and Upload
          </button>
        </div>
      </div>
    </div>
  </div>
}